import * as ACTION from '../constants';
import * as saga from './saga';
import {takeLatest} from 'redux-saga/effects';

export default function* () {
	yield takeLatest(ACTION.FETCH_LIST_WAREHOUSE.REQUEST, saga.fetchListWarehouse);
}
